export const trunk = {
  field: {
    my_ip: 'My IP Address',
    zorra_ip: 'Zorra IP Address',
    type: 'Direction',
    prefix: 'Prefix',
    state: 'Status',
    trunk_type: 'Service'
  },

  trunk_type: {
    inc_voice: 'Incoming calls',
    out_voice: 'Outgoing calls',
    pbx_inc_voice: 'Incoming calls PBX',
    pbx_out_voice: 'Outgoing calls PBX',
    autocaller_inc_voice: 'Incoming predictive dialer calls',
    autocaller_out_voice: 'Outgoing predictive dialer calls',
    call_number_verification: 'Number verification'
  },

  type: {
    outgoing: 'Outgoing',
    caller: 'Caller',
    incoming: 'Incoming',
    inc_voice: 'Incoming calls',
    out_voice: 'Outgoing calls',
    pbx_inc_voice: 'Incoming calls PBX',
    pbx_out_voice: 'Outgoing calls PBX',
    autocaller_inc_voice: 'Incoming calls Autoinformer',
    autocaller_out_voice: 'Outgoing calls Autoinformer',
    amo_inc_voice: 'Incoming voice widget amoCRM',
    amo_out_voice: 'Outgoing voice widget amoCRM',
    kommo_inc_voice: 'Incoming voice widget Kommo CRM',
    kommo_out_voice: 'Outgoing voice widget Kommo CRM',
    call_number_verification: 'Number verification',
    predictive_inc_voice: 'Predictive incoming calls',
    predictive_out_voice: 'Predictive outgoing calls',
    voice_number_verification: 'Incoming call verification with code dictation',
    phone_number_verification: 'Incoming call verification',
    all: 'All'
  },

  modal: {
    edit: 'Edit  SIP trunks',
    remove: {
      content: 'Are you sure you want to delete the trunk {name}?'
    },
    myip_tooltip: 'The main IP address is not editable.',
    ip_exist: 'IP address is already taken'
  },

  button: {
    create: 'Create trunk',
    tooltip: 'Charge your balance to create a trunk',
    show_default_trunks: 'Show default trunks'
  },

  errors: {
    trunk_limit: 'Trunks limit exceeded',
    ip_exist: 'IP address is already taken'
  },

  show_all: 'Show all'
};
